import React from "react";
import "./Home.css";
import Product from "./Product";
import Footer from "./Footer";
import { useStateValue } from "./StateProvider";
import { Avatar, IconButton } from '@material-ui/core';
import { InfoSection } from './components';
import { homeObjOne, homeObjFive, homeObjSix, homeObjSeven, homeObjEight } from './components/Data';
import { Link } from "react-router-dom";
import { Button } from './globalStyles';


function Home() {

  const [{ basket, user }, dispatch] = useStateValue();

  return (
    <div className="home" >
      <div >
<InfoSection {...homeObjFive} />
<InfoSection {...homeObjOne} />
        
        <Footer />
      </div>
    </div>
  );
}

export default Home;
